import React, {useEffect, useState} from 'react'
import PropTypes from 'prop-types'

import Header from '../components/molecules/Header'
import Footer from '../components/molecules/Footer'

import GlobalStyles from '../components/atoms/GlobalStyles'
import {ThemeProvider} from 'styled-components'
import {theme} from '../utils/styling'
import '../utils/fontface.css'
import PopupForm from '../components/organisms/PopupForm'
import PopupForm2 from '../components/organisms/PopupForm2'
import PopupForm3 from '../components/organisms/PopupForm3'
import CookieConsentPopup from '../components/atoms/CookieConsentPopup'
import {useWindowSize} from 'react-use'


const darkHeaders = ['/privacy']
const epaAnnouncementPages = ['/', '/how', '/why']
const inverseAnnouncementPages = ['/why']

function Index(props) {
    const size = useWindowSize()
    const [caseStudies, setCaseStudies] = useState(null)
    const dynamicPathname = /\/case-study\/(.*)/

    useEffect(() => {
        if (dynamicPathname.exec(props.location.pathname)) {
            setCaseStudies(true)
        } else {
            setCaseStudies(false)
        }
    }, [caseStudies, props.location])

    useEffect(() => {
        document.documentElement.style.setProperty('--windowHeight', `${size.height}px`)
    }, [size])

    return (
        <ThemeProvider theme={theme}>
            <>
                <GlobalStyles/>
                <Header
                    hide={props.location.pathname.includes('fleetbuilder')}
                    caseStudies={caseStudies}
                    showAnnouncement={epaAnnouncementPages.includes(props.location.pathname)}
                    inverseAnnouncement={inverseAnnouncementPages.includes(props.location.pathname)}
                    dark={darkHeaders.includes(props.location.pathname)}/>
                <main>{props.children}</main>
                <Footer
                    hide={props.location.pathname.includes('fleetbuilder')}/>
                <PopupForm/>
                <PopupForm2/>
                <PopupForm3/>
                <CookieConsentPopup/>
            </>
        </ThemeProvider>
    )
}

Index.propTypes = {
    children: PropTypes.node.isRequired,
}

export default Index
